import { PageHeaderProvider } from "@/providers/PageHeaderProvider";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/delivery",
)({
  component: RouteComponent,
  staticData: {
    meta: {
      title: "Levering",
    },
  },
  beforeLoad: async ({ context }) => {
    if (context.trialPeriod) {
      throw redirect({
        from: Route.fullPath,
        to: "/campaigns/$id",
      });
    }
  },
});

function RouteComponent() {
  return (
    <PageHeaderProvider
      options={{
        title: "Levering",
      }}
    >
      <div className="-m-8 -mt-4 flex grow flex-col xl:-m-14 xl:-mt-7">
        <Outlet />
      </div>
    </PageHeaderProvider>
  );
}
